import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/query-keys';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { cloudUrlParser } from '@/utils/aws-domain-util';
import { useApiBackendInfo } from './use-api-backend-info';
import { useGetSiteConfigs } from './use-site-configs';
import { streamingService } from '@/services/streaming.service';
import { SportMatchModel } from '@nf/types/odds';
import { useAccountInfo } from './account';

const fetchSlmtEventTags = async (url: string, token: string): Promise<number[]> => {
	try {
		const response = await fetchComposer.getWithBearer(
			cloudUrlParser(`${url}/Streaming/GetSlmtEvent`))(token);
		const data = await response.json();
		if (data?.errorCode == 0) {
			return Array.isArray(data?.data?.slmtEventTags) ? data?.data?.slmtEventTags : [];
		} else {
			throw new Error(data?.Data?.Message);
		}
	} catch (e) {
		return [];
	}
};

export const useSlmtGv = ({ match, sport }: {match: SportMatchModel, sport: string | string[]}) => {
	const { url, token } = useApiBackendInfo();
	const { user } = useAccountInfo();
	const hasDeposited =  user?.ActStatus === 2;
	const { SiteConfigsData } = useGetSiteConfigs();
	const EnableSlmtGv = hasDeposited && SiteConfigsData?.EnableSlmtGv && streamingService.isStreamingPlugin(match, sport, SiteConfigsData);
	const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
		queryKey: [queryKeys.SLMT_EVENT_TAGS, hasDeposited],
		queryFn: () => fetchSlmtEventTags(url, token),
		staleTime: 1000 * 10,
		cacheTime: 1000 * 10,
		refetchInterval: 1000 * 10,
		refetchOnWindowFocus: false,
		enabled: EnableSlmtGv
	});
	const hasSlmtGv =  EnableSlmtGv && data?.includes(match.MatchId);
	return {
		refetch,
		hasSlmtGv,
		isLoading,
		isError,
		error,
		isFetching
	};
};

